import type { InstrumentName } from '@tunasong/audio-ui'
import type { MelodyInstrumentHint } from '@tunasong/schemas'

/**
 * The soundfont a melody plays on. The hint is a TIMBRE, not a claim about what recorded it
 * (§4.2), so `voice` gets the piano rather than a vocal sample: a sampled "aah" has a slow attack
 * that blurs the note onsets this entity exists to preserve, and §4.2 names `acoustic_grand_piano`
 * as the alternative to a soft synth.
 */
const INSTRUMENTS: Record<MelodyInstrumentHint, InstrumentName> = {
  voice: 'acoustic_grand_piano',
  piano: 'acoustic_grand_piano',
  guitar: 'acoustic_guitar_steel',
}

export const melodyInstrument = (hint?: MelodyInstrumentHint): InstrumentName =>
  hint ? INSTRUMENTS[hint] : 'acoustic_grand_piano'
